module.exports = __webpack_public_path__ + "media/customizations/cannerydistrict/back-58fc4ea119ccfc0a979636be60e6d02f.jpg";